<template>
  <span>{{ formatted }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useCurrencyStore } from '~/stores/useCurrencyStore'

const currencyStore = useCurrencyStore()
const { n } = useI18n()

const {
    value = 0,
    currency
} = defineProps<{
  value: number;
  currency?: string;
}>()

const resolvedCurrency = computed(() => {
    return currency || currencyStore.currency
})

const formatted = computed(() => n(Number(value), { style: 'currency', currency: resolvedCurrency.value }))
</script>
